<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'App'
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  @import 'assets/scss/stylesheet';
  @import 'assets/scss/coreuistyle';
</style>
